

export default function RedirectToApp() {
  window.top.location.href = "https://dashboard.pbnjcode.com"
}